module.exports = "/fast-coin/img/coin/anim/in/coin_in_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_002.png
// module id = 2272
// module chunks = 5